module.exports = __webpack_public_path__ + "img/logo.61519a1.png";